import ComparisonResultsPageHero from "../../../../src/components/ComparisonResultsPageHero";
import ComparisonResultPageTextWithImageSection from "../../../../src/components/ComparisonResultPageTextWithImageSection";
import ComparisonResultHeroUserLocation from "../../../../src/components/ComparisonResultHeroUserLocation";
import ComparisonResultGrid from "../../../../src/components/ComparisonResultGrid";
import ComparisonResultColumnContent from "../../../../src/components/ComparisonResultColumnContent";
import ComparisonResultColumnContentBackgroundContainer from "../../../../src/components/ComparisonResultColumnContentBackgroundContainer";
import ComparisonResultGettingStartedBlock from "../../../../src/components/ComarisonResultPageGetStartedBlock";
import ComparisonPageRecommendations from "../../../../src/components/ComparisonPageRecommendations";
import ComparisonResultPageLearnMoreContainer from "../../../../src/components/ComparisonResultPageLearnMoreContainer";
import TVIllustration from "../../../../svg/ComparisonResultPageIllustrations/tvdeals.svg";
import ATandTSVG from "../../../../svg/ComparisonResultGridLogos/tvpackages/att.svg";
import DirectTVSVG from "../../../../svg/ComparisonResultGridLogos/tvpackages/directtv.svg";
import DishTVSVG from "../../../../svg/ComparisonResultGridLogos/tvpackages/dish.svg";
import SuddenLinkSVG from "../../../../svg/ComparisonResultGridLogos/tvpackages/suddenlink.svg";
import SpectrumSVG from "../../../../svg/ComparisonResultGridLogos/tvpackages/spectrum.svg";
import * as React from 'react';
export default {
  ComparisonResultsPageHero,
  ComparisonResultPageTextWithImageSection,
  ComparisonResultHeroUserLocation,
  ComparisonResultGrid,
  ComparisonResultColumnContent,
  ComparisonResultColumnContentBackgroundContainer,
  ComparisonResultGettingStartedBlock,
  ComparisonPageRecommendations,
  ComparisonResultPageLearnMoreContainer,
  TVIllustration,
  ATandTSVG,
  DirectTVSVG,
  DishTVSVG,
  SuddenLinkSVG,
  SpectrumSVG,
  React
};